import { render, staticRenderFns } from "./admin_permiss.vue?vue&type=template&id=632688f0&scoped=true&"
import script from "./admin_permiss.vue?vue&type=script&lang=js&"
export * from "./admin_permiss.vue?vue&type=script&lang=js&"
import style0 from "./admin_permiss.vue?vue&type=style&index=0&id=632688f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632688f0",
  null
  
)

export default component.exports